<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ action === 'Save' ? 'Add' : 'Update' }} Managed Client</span>
        </v-card-title>
        <v-form
          ref="form"
          method="post"
          action="/"
          lazy-validation
          @submit.prevent="saveOrUpdate()"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.name"
                    label="Client name"
                    placeholder="Client organization name"
                    :rules="[
                      v => !!v || 'Client name is required',
                    ]"
                    required
                  ></v-text-field>
                  <small
                    v-show="form.errors.has('name')"
                    class="validation-error"
                  >{{
                    form.errors.get('name')
                  }}</small>
                  <v-text-field
                    v-model="form.account_number"
                    label="Account number"
                    placeholder="Client's account number"
                    :rules="[
                      v => !!v || 'Account number is required',
                    ]"
                    required
                  ></v-text-field>
                  <small
                    v-show="form.errors.has('account_number')"
                    class="validation-error"
                  >{{
                    form.errors.get('account_number')
                  }}</small>
                  <v-text-field
                    v-model="form.backend_url"
                    label="Backend URL"
                    placeholder="Client's backend API URL"
                    hint="Will be used for API communications"
                    :rules="[
                      v => !!v || 'Backend URL is required',
                      v => (v && isValidUrl(v)) || 'Please enter a valid URL'
                    ]"
                    required
                  ></v-text-field>
                  <small
                    v-show="form.errors.has('backend_url')"
                    class="validation-error"
                  >{{
                    form.errors.get('backend_url')
                  }}</small>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="closeDialog()"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              type="submit"
              :loading="form.busy"
            >
              {{ action }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Form from 'vform'
import { mapActions } from 'vuex'

export default {
  props: {
    showDialog: {
      type: Boolean,
    },
    client: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    form: new Form({
      name: '',
      account_number: '',
      backend_url: '',
      id: '',
    }),
    action: 'Save',
  }),
  watch: {
    client() {
      if (Object.keys(this.client).length > 0) {
        this.form.update(this.client)
        this.action = 'Update'
      } else {
        this.action = 'Save'
      }
    },
  },
  methods: {
    ...mapActions(['refreshClients']),
    closeDialog() {
      this.$emit('close')
      this.$refs.form.reset()
    },
    isValidUrl(url) {
      try {
        new URL(url)
        return true
      } catch (e) {
        return false
      }
    },
    saveOrUpdate() {
      const isFormValid = this.$refs.form.validate()
      if (isFormValid) {
        if (this.action === 'Save') {
          this.saveClient()
        } else {
          this.updateClient()
        }
      }
    },
    saveClient() {
      this.form
        .post('managed-clients')
        .then(() => {
          this.$notification.success('Client added successfully')
          this.$emit('close')
          this.$emit('client-added')
          this.refreshClients(true)
          this.$refs.form.reset()
        })
        .catch(error => {
          this.$notification.error(error.response.data.message)
        })
    },
    updateClient() {
      this.form
        .put(`managed-clients/${this.form.id}`)
        .then(() => {
          this.$notification.success('Client updated successfully')
          this.$emit('close')
          this.$emit('client-added')
          this.refreshClients(true)
          this.$refs.form.reset()
        })
        .catch(error => {
          this.$notification.error(error.response.data.message)
        })
    },
  },
}
</script>

<style scoped>
.validation-error {
  color: #ff5252;
  font-size: 12px;
  margin-top: -15px;
  margin-bottom: 10px;
  display: block;
}
</style>
